module.exports = __webpack_public_path__ + "static/media/news-cdphp-heather.3562fcea.jpg";